import { B as BiLogo$1, d as defineCustomElement$1 } from './p-9295cec1.js';

const BiLogo = BiLogo$1;
const defineCustomElement = defineCustomElement$1;

export { BiLogo, defineCustomElement };
